export const GA_MEASUREMENT_ID = 'G-NW5DSLQPZK';

export const pageview = (url) => {
  if (window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

export const trackEvent = (action, params) => {
  if (window.gtag) {
    window.gtag('event', action, params);
  }
};
